const frontendMessages = {
  containerSelector: '.message-container',
  showError: message => {

    const container = document.querySelector(frontendMessages.containerSelector);
    container.innerHTML = `<div class="error-message">${message}</div>`;

  },

  showSuccess: message => {

    const container = document.querySelector(frontendMessages.containerSelector);
    container.innerHTML = `<div class="success-message">${message}</div>`;

  },

};

export default frontendMessages;
